import AttendeeForm from './AttendeeForm';

export default AttendeeForm;
